// api/cloudinary.ts
import axiosInstance from './axiosInstance';
import cloudinaryAxios from './cloudinaryAxiosInstance';
import { ApiResponse, CloudinarySignatureResponse, CloudinaryUploadResponse } from './types';

export const getCloudinarySignature = async (): Promise<
  ApiResponse<CloudinarySignatureResponse>
> => {
  try {
    const res = await axiosInstance.get<CloudinarySignatureResponse>(
      '/cloudinary/cloudinary-signature'
    );
    return { data: res.data, error: null };
  } catch (err: any) {
    const errorMessage = err.response?.data?.message || err.message || 'Unknown error';
    return { data: null, error: errorMessage };
  }
};

export const uploadImageToCloudinarySigned = async (
  file: File
): Promise<ApiResponse<CloudinaryUploadResponse>> => {
  try {
    // 1) get signature
    const sig = await getCloudinarySignature();
    if (sig.error || !sig.data) {
      return { data: null, error: sig.error ?? 'Could not get signature' };
    }
    const { signature, timestamp, cloudName, apiKey, folder } = sig.data;

    // 2) post to Cloudinary (NOTE: NOT via your axiosInstance baseURL)
    const formData = new FormData();
    formData.append('file', file);
    formData.append('api_key', apiKey);
    formData.append('timestamp', String(timestamp));
    formData.append('signature', signature);
    if (folder) formData.append('folder', folder);

    // using different axios instance without credentials turned on as it gives cors error
    const res = await cloudinaryAxios.post<CloudinaryUploadResponse>(
      `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    );


    return { data: res.data, error: null };
  } catch (err: any) {
    const errorMessage =
      err.response?.data?.error?.message ||
      err.response?.data?.message ||
      err.message ||
      'Unknown error';
    return { data: null, error: errorMessage };
  }
};
